import konsole from './modules/konsole';

const noop = function() {};

const isObject = function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
};

const mergeDeep = function mergeDeep(target /*, many, of, args */) {
  var sources = Array.prototype.slice.call(arguments, 1);
  for (var s = 0; s < sources.length; s++) {
    var source = sources[s];
    if (isObject(target) && isObject(source)) {
      var keys = Object.keys(source), i = 0, key;
      for (; i < keys.length; i++) {
        key = keys[i];
        if (isObject(source[key])) {
          if (!target[key]) { target[key] = {}; }
          mergeDeep(target[key], source[key]);
        }
        else {
          target[key] = source[key];
        }
      }
    }
  }
  return target;
};


const el_liveBind = function el_liveBind(element, event, descendentSelector, callback, evtOpts) {
  var eventNames = event.trim().split(/\s+/);
  evtOpts = typeof evtOpts !== "undefined" ? evtOpts : {passive: false};

  function listener(e) {
    var elem = descendentSelector ? e.target.closest(descendentSelector) : element;
    if (elem && typeof callback === 'function') {
      callback.call(elem, e, elem, unbind);
    }
  }

  function unbind(e) {
    for (var i = 0; i < eventNames.length; i++) {
      element.removeEventListener(eventNames[i], listener);
    }
  };

  for (var i = 0; i < eventNames.length; i++) {
    element.addEventListener(eventNames[i], listener, evtOpts);
  }

  return unbind;
};


const el_trigger = function el_trigger(el, event, data, bubbles = true, cancelable = false) {
  var eventNames = event.trim().split(/\s+/);
  if (!el || !el.dispatchEvent) {
    konsole.error('el_trigger() Invalid arg0 "el":', el, event);
    return;
  }
  for (var i = 0; i < eventNames.length; i++) {
    el.dispatchEvent(
      new window.CustomEvent(eventNames[i], {
        bubbles: !!bubbles,
        cancelable: !!cancelable,
        detail: { customEvent: true, customData: data || null }
      })
    );
  }
};


const el_getHeight = function el_getHeight(el) {
  var styles = window.getComputedStyle(el);
  var height = el.offsetHeight;
  var borderTopW = parseFloat(styles.borderTopWidth);
  var borderBottomW = parseFloat(styles.borderBottomWidth);
  var paddingTop = parseFloat(styles.paddingTop);
  var paddingBottom = parseFloat(styles.paddingBottom);
  return height - borderBottomW - borderTopW - paddingTop - paddingBottom;
};


/**
 * Getter to return sibling elements of the passed one
 * @param elem: HTMLElement
 * @return {Array} Array of sibling elements.
 */
const getSiblingsElements = function(elem) {
  const siblings = [];

  if (elem && elem.parentNode) {
    let sibling = elem.parentNode.firstChild;

    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== elem) { siblings.push(sibling); }
      sibling = sibling.nextSibling;
    }
  }

  return siblings;
};



const keyCodes = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};


// legacy es5 code
const _u = (function($, _PHP) {
  return {
    /**
     * @name _u.gaSend
     * @description ga.js proxy
     * @param {String}        hitType       The type of hit. Must be one of 'pageview', 'screenview', 'event', 'transaction', 'item', 'social', 'exception', 'timing'.
     * @param {String}        eventCategory Specifies the event category. Must not be empty.
     * @param {String}        eventAction   Specifies the event action. Must not be empty.
     * @param {String|Object} [_eventLabel] Specifies the event label or {label:value} pair;
     * @param {Number}        [_eventValue] Specifies the event value. Values must be non-negative.
     */
    gaSend: function(method, hitType, eventCategory, eventAction, _eventLabel, _eventValue) {
      if (typeof window.ga === "function") {
        window.ga(method, hitType, eventCategory, eventAction, _eventLabel, _eventValue);
      }
    },
    isTouchDevice: function() {
      return (('ontouchstart' in window) ||
        (navigator.MaxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)
      );
    },
    isMobile: (function() {
      var r = (/Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent));
      if (r) {
        $(document.documentElement).addClass('mobile');
      }
      return r;
    })(),
    // URL suffix for changeable images.
    cache_stamp: Math.round($.now() / 1000 / 60 / 60 / 2), // (max 2 hours)
    // random number from within a range
    getRand: function(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    // Zero padding
    zeroFill: function(num, len) {
      return ((num < 0 ? "-" : "") + (
        Math.pow(10, len) <= Math.abs(num) ? ("0" + Math.abs(num)) : (Math.pow(10, len) + Math.abs(num))
      ).toString().substr(1));
    },

    array_shuffle: function(array) {
      var tmp, current, top = array.length;
      if (top) {
        while (--top) {
          current = Math.floor(Math.random() * (top + 1));
          tmp = array[current];
          array[current] = array[top];
          array[top] = tmp;
        }
      }
      return array;
    },

    arraySortBy: function(arr, which, reverse, insensitive) {
      var t = $.type(which),
        r = (typeof reverse !== "undefined" && reverse) ? -1 : 1;
      return arr.sort(function(a, b) {
        var v = (t === "function" ? {
          A: (which.call(arr, a) || 0),
          B: (which.call(arr, b) || 0)
        } : ((t === "string" || t === "number") ? {
          A: (a[which] || 0),
          B: (b[which] || 0)
        } : {
          A: a,
          B: b
        }));
        if (insensitive) {
          if (typeof v.A === "string") {
            v.A = v.A.toLowerCase();
          }
          if (typeof v.B === "string") {
            v.B = v.B.toLowerCase();
          }
        }
        return ((v.A < v.B) ? -1 : ((v.A > v.B) ? 1 : 0)) * r;
      });
    },

    addObjPropAsArray: function(to, x, v) {
      if (typeof to !== "object" || typeof v === 'undefined') {
        return !1;
      }
      if (typeof to[x] === "object" && to[x] instanceof Array) {
        to[x].push(v);
      }
      else {
        to[x] = [v];
      }
      return to[x];
    },

    validateEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    getHeaderHeight() {
      var $head = $('#w_head');
      if ($head.css('position') === 'fixed') {
        return $head.height();
      }
      return 0;
    },
    scrollTo: function(_to, dur, fn, _offset) {
      var offset = _offset || -7;
      var $win = $(window);
      var duration = 0;
      var headerOffset = this.getHeaderHeight();

      if (typeof dur === "object") {
        duration = typeof dur.duration === "number" ? dur.duration : 0;
      }
      else {
        duration = (dur - 0) || 0;
      }

      var settings = {
        duration: duration,
        axis: 'y',
        interrupt: false,
        offset: (0 - headerOffset) + offset,
        onAfter: fn || $.noop,
        scrollHeight: document.body.scrollHeight,
        progress: function() {
          if (settings.scrollHeight !== document.body.scrollHeight) {
            settings.scrollHeight = document.body.scrollHeight;
            $win.stop(true);
            $.scrollTo(_to, settings);
          }
        }
      };

      if (typeof dur === "object") {
        $.extend(settings, dur);
      }

      $win.stop(true);
      $.scrollTo(_to, settings);

      return this;
    },
    detectIE: function detectIE() {
      /**
      * detect IE
      * returns version of IE or false, if browser is not Internet Explorer
      */
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;
    },
    setFbCanvasSize: (function() {
      var body = document.body,
        html = document.documentElement,
        $win = $(window),
        oldHeight = 0,
        height = 1000;

      function getHeight() {
        return Math.max(
          body.scrollHeight, body.offsetHeight
          , html.clientHeight, html.scrollHeight, html.offsetHeight
        );
      }

      function setHeight(force) {
        height = getHeight();
        if (typeof window.FB === "undefined" || !window.FB.Canvas) {
          return;
        }
        if (force || (oldHeight !== height)) {
          oldHeight = height;
          $win.resize();
          window.FB.Canvas.setSize({
            height: height
          });
        }
      }

      window.setInterval(function() {
        setHeight();
      }, 5000);

      return setHeight;

    })()
  };
})(window.jQuery, window._PHP || {});


function _ga() {
  if (typeof ga === "function") {
    // eslint-disable-next-line no-undef
    ga.apply(this, arguments);
  }
}

const elemIsVisible = function(el) {
  return el.offsetParent !== null || (el.offsetWidth && el.offsetHeight);
};

const getScrollbarWidth = (() => {
  let memoized = null;
  function getScrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    const inner = document.createElement('div');
    outer.appendChild(inner);
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }

  return () => {
    if (memoized !== null) {
      return memoized;
    }
    return (memoized = getScrollbarWidth());
  };
})();



// todo module verion of:
const $ = window.jQuery;
const fastdom = window.fastdom;
const doT = window.doT;
const _ = window._;
const iFrameResize = window.iFrameResize;
const rx = {
  is_asset: /\.(jpe?g|png|pdf|svg)(\?.*)?$/i,
  is_in_the_img_forder: /^\/img\//i
};


/**
 * A stateless keyboard utility to -
 * - Trap focus,
 * - Focus the correct Element
 * @param el_wrapper: HTMLElement. The Parent element, within which the focus should be trapped
 * @param el_for_initial_focus: <Optional> HTMLElement. If Not provided, focus is put to the first focusable element
 * @return {Function} Function. The cleanup function. To undo everything done for handling A11Y
 */

const trapFocus = (function() {
  const FOCUSABLES = (
    '[role="button"], a[href], area[href], input, select, textarea, button, iframe, object, [tabindex="0"], [contenteditable]'
  ).split(/,\s+?/).join(':not([disabled]), ');

  const isVisible = el => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

  return function(el_wrapper, el_for_initial_focus, escFn) {
    if (!el_wrapper) {
      throw new Error('Could not initialize focus-trapping - Element Missing');
    }

    const focusableElements = Array.prototype.slice.call(
      el_wrapper.querySelectorAll(FOCUSABLES), 0
    ).filter(isVisible);

    let keyboardHandler;

    if (focusableElements.length > 0) {
      const firstFocusableEl = focusableElements[0];
      const lastFocusableEl = focusableElements[focusableElements.length - 1];
      const el_autofocus = el_wrapper.querySelector('[autofocus]');
      const elementToFocus = el_for_initial_focus || (
        el_autofocus || firstFocusableEl
      );
      elementToFocus.focus();

      keyboardHandler = function(e) {
        if (e.keyCode === 9) { // Tab key
          if (e.shiftKey && document.activeElement === firstFocusableEl) {
            e.preventDefault();
            lastFocusableEl.focus();
          }
          else if (!e.shiftKey && document.activeElement === lastFocusableEl) {
            e.preventDefault();
            firstFocusableEl.focus();
          }
        }
        else if (e.keyCode === 27) { // Esc key

          if (typeof escFn === 'function') {
            if (escFn(e) === false) {
              e.preventDefault();
            }
          }
        }
      };

      el_wrapper.addEventListener('keydown', keyboardHandler);
    }

    return function cleanUp() {
      if (keyboardHandler) {
        el_wrapper.removeEventListener('keydown', keyboardHandler);
      }
    };
  };
})();



const util = {
  trapFocus,
  noop,
  konsole,
  isObject,
  mergeDeep,
  el_liveBind,
  el_trigger,
  el_getHeight,
  getSiblingsElements,
  keyCodes,
  _u,
  $,
  elemIsVisible,
  _ga,
  fastdom,
  doT,
  _,
  iFrameResize,
  rx,
  getScrollbarWidth
};


export {
  trapFocus,
  noop,
  konsole,
  isObject,
  mergeDeep,
  el_liveBind,
  el_trigger,
  el_getHeight,
  getSiblingsElements,
  keyCodes,
  _u,
  $,
  elemIsVisible,
  _ga,
  fastdom,
  doT,
  _,
  iFrameResize,
  rx,
  getScrollbarWidth
};

export default util;
